module.exports = __webpack_public_path__ + "img/high-vaccum-filter.6cf8ae04.png";